import React, { useEffect, useState } from 'react';
import './payment-container.styles.scss';
import { loadStripe } from '@stripe/stripe-js'
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useStripe, useElements, CheckoutProvider, EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import StripePayment from './stripe-form.component';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import { appearance } from '@/utils/stripe-appearance';

const StripeContainer = ({ totalCost, setSuccess, primaryReg, paymentDetails, eventData, cancelPayment }) => {

    const userProfile = useSelector((state) => state.userData.userProfile);
    const screenSize = useSelector((state) => state.contentData.screenSize);
    const navigate = useNavigate();
    
    let STRIPE_PUBLISHABLE_KEY = import.meta.env[`VITE_STRIPE_PUBKEY_TEST`];
    if (!window.location.pathname.includes('test_')) {
        STRIPE_PUBLISHABLE_KEY = import.meta.env[`VITE_STRIPE_PUBKEY_LIVE`];
    }
    const [ stripePromise, setStripePromise ] = useState(() => loadStripe(STRIPE_PUBLISHABLE_KEY));
    const [ clientSecret ] = useState();
    const [ options, setOptions ] = useState({});
    const [ prices ] = useState({
        'test_promonthly': {
            'name': 'Monthly Pro Plan',
            'id': 'price_1R035PJ3XXfvH0zSUR4da5Yk'
        },
        'test_proannual': {
            'name': 'Annual Pro Plan',
            'id': 'price_1R035PJ3XXfvH0zSv5ArD4su'
        },
        'test_premiummonthly': {
            'name': 'Monthly Premium Plan', 
            'id': 'price_1R0459J3XXfvH0zS3MvCEkWV'
        },
        'test_premiumannual': {
            'name': 'Annual Premium Plan',
            'id': 'price_1R045zJ3XXfvH0zSy6yM3fPt'
        },
        'promonthly': {
            'name': 'Monthly Pro Plan',
            'id': 'price_1ROtLHJ3XXfvH0zSwjUol3uC'
        },
        'proannual': {
            'name': 'Annual Pro Plan',
            'id': 'price_1ROtMBJ3XXfvH0zSUCz34OAk'
        },
        'premiummonthly': {
            'name': 'Monthly Premium Plan',
            'id': 'price_1ROtN2J3XXfvH0zSbnAnnrgQ'
        },
        'premiumannual': {
            'name': 'Annual Premium Plan',
            'id': 'price_1ROtOpJ3XXfvH0zSqD21URs1'
        },
    });
    const { product } = useParams();
    const location = useLocation();

    useEffect(() => {
        // if (!totalCost) {return;}
        // console.log(STRIPE_PUBLISHABLE_KEY);
        // async function getClientSecret() {
        //     const cs = await UseCloudFunction('getStripeSecret', {'total': totalCost, 'primaryReg': primaryReg, 'paymentDetails': paymentDetails, 'paymentProcessor': eventData.paymentProcessor});
        //     // alert(cs);
        //     console.log(cs);
        //     setClientSecret(cs);
        //     setOptions({clientSecret: cs,})
        // }
        // getClientSecret();
        if (!product) return;
        changeDocumentTitle(`Purchase - ${prices[product]?.name || 'Stripe Payment'}`);
        
        // getCheckoutSession();
    }, [product])

    async function fetchClientSecret() {
        const priceId = prices[product].id;
        if (!priceId) return;
        if (!userProfile) {
            navigate(`/signin?successUrl=${location.pathname}`);
            return;
        }
        let isTest = true;
        let customerId = userProfile.stripeCustomerIdTest;
        if (!location.pathname.includes('test_')) {
            customerId = userProfile.stripeCustomerId;
            isTest = false;
        }
        const session = await UseCloudFunction(
            'getStripeCheckoutSession', 
            { 
                'lineItems': [{
                    'price': priceId,
                    'quantity': 1
                }],
                'appId': userProfile.appId, 
                'customerName': `${userProfile.fName} ${userProfile.lName}`,
                'customerEmail': userProfile.email,
                'customerId': customerId,
                'url': window.location.origin,
                'isTest': isTest,
             }
        );
        console.log(session);
        return session.clientSecret;
        // setOptions(session)
    }

    return (
        <UnauthLayout>
        <div className={`payment-container `}>
            {/* <div className='product-div'>
                {
                    (product && prices[product]) &&
                    <h2>{prices[product].name}</h2>
                } 
            </div>
            <div className="g-space-1"></div> */}
            <div className='payment-div'>
                {/* <CheckoutProvider
                    stripe={stripePromise}
                    options={
                        {
                            fetchClientSecret,
                            elementsOptions: {
                                appearance,
                            },
                        }}>
                        <StripePayment
                            />
                    </CheckoutProvider> */}
                {
                    (stripePromise && userProfile) &&
                    <EmbeddedCheckoutProvider
                        stripe={stripePromise}
                        options={{fetchClientSecret}}>
                        <EmbeddedCheckout />
                    </EmbeddedCheckoutProvider>
                }
            </div>
        </div>
        </UnauthLayout>
    )
}

export default StripeContainer